import "core-js/stable";
import { ElectricVehicles } from "./API/ElectricVehicles";
import { ByBodyType } from "./API/ByBodyType";

// Fill Year Dropdowns
let minYear = $("#min-year");
let maxYear = $("#max-year");
let currentMinYear = minYear.data("min-year");
let currentMaxYear = maxYear.data("max-year");
let earliestYear = 1998;
let latestYear = 2024;

for (var i = latestYear; i >= earliestYear; i--) {
  let minOption = document.createElement("option");
  minOption.text = i.toString();
  minOption.value = i.toString();
  let maxOption = minOption.cloneNode(true);
  if (i == currentMinYear) {
    $(minOption).attr("selected", "selected");
  }
  if (i == currentMaxYear) {
    $(maxOption).attr("selected", "selected");
  }
  minYear.append(minOption);
  maxYear.append(maxOption);
}

$(".filter-header").on("click", (event) => {
  // Toggle Filter sections on header/arrow click
  let target = $(event.currentTarget);
  target.children(".bulma-arrow-mixin").toggleClass("is-open");
  target.siblings(".field").toggleClass("is-hidden");
});

$(".close-btn, .filter-results").on("click", () => {
  toggleMobileFilters();
});

function toggleMobileFilters() {
  $(".left-rail").toggleClass("is-hidden-touch");
  $(".mobile-filtering").toggleClass("close-mobile-filtering");
  $(".close-btn").toggleClass("is-hidden");
  $(".mobile-filtering-menu").toggleClass("is-hidden");
}

/**
 * Add event listeners to each filter
 */

function CarsForSaleFactory() {
  switch ($("body").data("page-type")) {
    case "ElectricVehicles":
      return new ElectricVehicles();
    case "ByBodyType":
      return new ByBodyType();
    default:
      throw new Error("Invalid page type");
  }
}

let carsFactory = CarsForSaleFactory();
carsFactory.initializeFilters();

$(".api-filter").on("change", (event) => {
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  carsFactory.setFilter(
    $(event.target).attr("name"),
    $(event.target).val().toString()
  );
  carsFactory.filter();
});

$("#make-selector").on("change", (event) => {
  carsFactory.redirectTo("make", [$(event.target).val().toString()]);
});

$("#model-selector").on("change", (event) => {
  carsFactory.redirectTo("model", [$(event.target).val().toString()]);
});

$("#min-year, #max-year").on("change", (event) => {
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  carsFactory.setFilter(
    $(event.target).attr("name"),
    $(event.target).val().toString()
  );
  carsFactory.filter();
});

$(".radio-filter").on("change", (event) => {
  $(".radio-filter:checked").each((key, value) => {
    carsFactory.setFilter(
      $(event.target).attr("name"),
      $(value).val().toString()
    );
    carsFactory.filter();
  });
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
});

$(".checkbox-filters").on("click", (event) => {
  let fieldName = $(event.target).attr("name");
  carsFactory.deleteFilter(fieldName);
  $(`input[name="${fieldName}"]:checked`).each((key, value) => {
    carsFactory.appendFilter(fieldName, $(value).val().toString());
  });
  if (!$(".left-rail").hasClass("is-hidden-touch")) {
    toggleMobileFilters();
  }
  carsFactory.filter();
});

const filterForms = $(".left-rail-form");
for (let i = 0; i < filterForms.length; i++) {
  $(filterForms[i]).on("submit", (e) => {
    e.preventDefault();
    let form = $(e.target);
    let inputlist = $(filterForms[i]).find("input");
    inputlist.each((index, element) => {
      let name = $(element).attr("name");
      if (name == "zip" && !isValidZipCode($(element).val())) {
        displayError(form, $(element));
      } else {
        hideError(form, $(element));
        if (!$(".left-rail").hasClass("is-hidden-touch")) {
          toggleMobileFilters();
        }
        carsFactory.setFilter(
          $(element).attr("name"),
          $(element).val().toString()
        );
        carsFactory.filter();
      }
    });
  });
}

$(".sortby__btn, .sortby-mobile").on("change", (event) => {
  let params = new URLSearchParams($(event.target).val().toString());
  params.forEach((value, key) => {
    carsFactory.setFilter(key, value);
  });
  carsFactory.sortBy(params);
});

// Helpers

function isValidZipCode(zipCode) {
  return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
}

function displayError(form, input) {
  form.addClass("error");
  input.addClass("is-danger");
  form.find(".help").removeClass("is-hidden");
}

function hideError(form, input) {
  form.removeClass("error");
  input.removeClass("is-danger");
  form.find(".help").addClass("is-hidden");
}
